const getPercent = (num, count) => {
    if (count == 0 || num == 0) {
        return `0%`;
    }
    let rate = Number((num / count) * 100).toFixed(2)

    if (String(rate).indexOf(".00") !== -1) {
        rate = String(rate).replace(".00", "");
    }

    return `${rate}%`;
};

export const getPassRateTableData = (data) => {
    const list = [

    ];

    const qualityTotal = {
        count: 0,
        onceSubmissionNum: 0,
        onceQualifiedNum: 0,
        onceRate: 0,
        secondSubmissionNum: 0,
        secondQualifiedNum: 0,
        secondRate: 0,
        geThriceSubmissionNum: 0,
        geThriceQualifiedNum: 0,
        geThriceRate: 0,
        returnedNum: 0,
        returnedRate: 0,
    };


    const getRate = (data) => {

        const quality = {
            count: data.total,
            onceSubmissionNum: data.onceSubmissionNum,
            onceQualifiedNum: data.onceQualifiedNum,
            onceRate: getPercent(data.onceQualifiedNum, data.onceSubmissionNum),
            secondSubmissionNum: data.secondSubmissionNum,
            secondQualifiedNum: data.secondQualifiedNum,
            secondRate: getPercent(data.secondQualifiedNum, data.secondSubmissionNum),
            geThriceSubmissionNum: data.geThriceSubmissionNum,
            geThriceQualifiedNum: data.geThriceQualifiedNum,
            geThriceRate: getPercent(data.geThriceQualifiedNum, data.geThriceSubmissionNum),
            returnedNum: data.returnedNum,
            returnedRate: getPercent(data.returnedNum, data.total),
        };

        return quality;
    };

    Object.keys(data).forEach((key) => {
        const qualityInspectionData = data[key];
        const modalStatistics = getRate(qualityInspectionData);

        list.push({
            name: key,
            data: modalStatistics
        });
        Object.keys(qualityTotal).forEach((key) => {
            qualityTotal[key] += modalStatistics[key];
        });
    });

    console.log(qualityTotal, 'qualityTotal')

    qualityTotal.onceRate = getPercent(qualityTotal.onceQualifiedNum, qualityTotal.onceSubmissionNum);
    qualityTotal.secondRate = getPercent(qualityTotal.secondQualifiedNum, qualityTotal.secondSubmissionNum);
    qualityTotal.geThriceRate = getPercent(qualityTotal.geThriceQualifiedNum, qualityTotal.geThriceSubmissionNum);
    qualityTotal.returnedRate = getPercent(qualityTotal.returnedNum, qualityTotal.count);


    list.unshift({
        name: '总计',
        data: qualityTotal
    });

    return list;

    if (!data['swan 600'] && !data['swan 600P']) return list;

    let swan600Total = 0;
    let onceSwan600SubmissionNum = 0;
    let onceSwan600QualifiedNum = 0;
    let secondSwan600SubmissionNum = 0;
    let secondSwan600QualifiedNum = 0;
    let geThriceSwan600SubmissionNum = 0;
    let geThriceSwan600QualifiedNum = 0;
    let returnedSwan600Num = 0;

    let swan600PTotal = 0;
    let onceSwan600PSubmissionNum = 0;
    let onceSwan600PQualifiedNum = 0;
    let secondSwan600PSubmissionNum = 0;
    let secondSwan600PQualifiedNum = 0;
    let geThriceSwan600PSubmissionNum = 0;
    let geThriceSwan600PQualifiedNum = 0;
    let returnedSwan600PNum = 0;

    if (data['swan 600']) {
        const {
            total,
            onceSubmissionNum,
            onceQualifiedNum,
            secondSubmissionNum,
            secondQualifiedNum,
            geThriceSubmissionNum,
            geThriceQualifiedNum,
            returnedNum
        } = data['swan 600'];

        swan600Total = total;
        onceSwan600SubmissionNum = onceSubmissionNum;
        onceSwan600QualifiedNum = onceQualifiedNum;
        secondSwan600SubmissionNum = secondSubmissionNum;
        secondSwan600QualifiedNum = secondQualifiedNum;
        geThriceSwan600SubmissionNum = geThriceSubmissionNum;
        geThriceSwan600QualifiedNum = geThriceQualifiedNum;
        returnedSwan600Num = returnedNum;
    }

    if (data['swan 600P']) {
        const {
            total,
            onceSubmissionNum,
            onceQualifiedNum,
            secondSubmissionNum,
            secondQualifiedNum,
            geThriceSubmissionNum,
            geThriceQualifiedNum,
            returnedNum
        } = data['swan 600P'];

        swan600PTotal = total;
        onceSwan600PSubmissionNum = onceSubmissionNum;
        onceSwan600PQualifiedNum = onceQualifiedNum;
        secondSwan600PSubmissionNum = secondSubmissionNum;
        secondSwan600PQualifiedNum = secondQualifiedNum;
        geThriceSwan600PSubmissionNum = geThriceSubmissionNum;
        geThriceSwan600PQualifiedNum = geThriceQualifiedNum;
        returnedSwan600PNum = returnedNum;
    }


    list.push({
        text: "",
        total: swan600Total + swan600PTotal,
        swan600: swan600Total,
        swan600P: swan600PTotal,
    });

    // const { onceSwan600SubmissionNum, onceSwan600PSubmissionNum, onceSwan600QualifiedNum, onceSwan600PQualifiedNum } = data;

    // const { secondSwan600SubmissionNum, secondSwan600PSubmissionNum, secondSwan600QualifiedNum, secondSwan600PQualifiedNum } = data;

    // const { geThriceSwan600SubmissionNum, geThriceSwan600PSubmissionNum, geThriceSwan600QualifiedNum, geThriceSwan600PQualifiedNum } = data;

    // const { quarticSubSwan600, quarticSubSwan600P, quarticSwan600, quarticSwan600P } = data;

    // const { quinticSubSwan600, quinticSubSwan600P, quinticSwan600, quinticSwan600P } = data;

    // const { returnedTotal, returnedSwan600, returnedSwan600P } =
    //     data;

    list.push({
        text: "一次送检数量",
        total: onceSwan600SubmissionNum + onceSwan600PSubmissionNum,
        swan600: onceSwan600SubmissionNum,
        swan600P: onceSwan600PSubmissionNum,
    });

    list.push({
        text: "一次合格数量",
        total: onceSwan600QualifiedNum + onceSwan600PQualifiedNum,
        swan600: onceSwan600QualifiedNum,
        swan600P: onceSwan600PQualifiedNum,
    });


    list.push({
        text: "一次合格率",
        total: getPercent(onceSwan600QualifiedNum + onceSwan600PQualifiedNum, onceSwan600SubmissionNum + onceSwan600PSubmissionNum),
        swan600: getPercent(onceSwan600QualifiedNum, onceSwan600SubmissionNum),
        swan600P: getPercent(onceSwan600PQualifiedNum, onceSwan600PSubmissionNum),
    });

    list.push({
        text: "二次送检数量",
        total: secondSwan600SubmissionNum + secondSwan600PSubmissionNum,
        swan600: secondSwan600SubmissionNum,
        swan600P: secondSwan600PSubmissionNum,
    });

    list.push({
        text: "二次合格数量",
        total: secondSwan600QualifiedNum + secondSwan600PQualifiedNum,
        swan600: secondSwan600QualifiedNum,
        swan600P: secondSwan600PQualifiedNum,
    });

    list.push({
        text: "二次合格率",
        total: getPercent(secondSwan600QualifiedNum + secondSwan600PQualifiedNum, secondSwan600SubmissionNum + secondSwan600PSubmissionNum),
        swan600: getPercent(secondSwan600QualifiedNum, secondSwan600SubmissionNum),
        swan600P: getPercent(secondSwan600PQualifiedNum, secondSwan600PSubmissionNum),
    });

    list.push({
        text: "三次送检数量",
        total: geThriceSwan600SubmissionNum + geThriceSwan600PSubmissionNum,
        swan600: geThriceSwan600SubmissionNum,
        swan600P: geThriceSwan600PSubmissionNum,
    });

    list.push({
        text: "三次合格数量",
        total: geThriceSwan600QualifiedNum + geThriceSwan600PQualifiedNum,
        swan600: geThriceSwan600QualifiedNum,
        swan600P: geThriceSwan600PQualifiedNum,
    });
    list.push({
        text: "三次合格率",
        total: getPercent(geThriceSwan600QualifiedNum + geThriceSwan600PQualifiedNum, geThriceSwan600SubmissionNum + geThriceSwan600PSubmissionNum),
        swan600: getPercent(geThriceSwan600QualifiedNum, geThriceSwan600SubmissionNum),
        swan600P: getPercent(geThriceSwan600PQualifiedNum, geThriceSwan600PSubmissionNum),
    });

    // list.push({
    //     text: "四次送检数量",
    //     total: quarticSubSwan600 + quarticSubSwan600P,
    //     swan600: quarticSubSwan600,
    //     swan600P: quarticSubSwan600P,
    // });

    // list.push({
    //     text: "四次合格数量",
    //     total: quarticSwan600 + quarticSwan600P,
    //     swan600: quarticSwan600,
    //     swan600P: quarticSwan600P,
    // });

    // list.push({
    //     text: "四次合格率",
    //     total: getPercent(quarticSwan600 + quarticSwan600P, quarticSubSwan600 + quarticSubSwan600P),
    //     swan600: getPercent(quarticSwan600, quarticSubSwan600),
    //     swan600P: getPercent(quarticSwan600P, quarticSubSwan600P),
    // });

    // list.push({
    //     text: "五次送检数量",
    //     total: quinticSubSwan600 + quinticSubSwan600P,
    //     swan600: quinticSubSwan600,
    //     swan600P: quinticSubSwan600P,
    // });

    // list.push({
    //     text: "五次合格数量",
    //     total: quinticSwan600 + quinticSwan600P,
    //     swan600: quinticSwan600,
    //     swan600P: quinticSwan600P,
    // });

    // list.push({
    //     text: "五次合格率",
    //     total: getPercent(quinticSwan600 + quinticSwan600P, quinticSubSwan600 + quinticSubSwan600P),
    //     swan600: getPercent(quinticSwan600, quinticSubSwan600),
    //     swan600P: getPercent(quinticSwan600P, quinticSubSwan600P),
    // });


    list.push({
        text: "退回未送检数量",
        total: returnedSwan600Num + returnedSwan600PNum,
        swan600: returnedSwan600Num,
        swan600P: returnedSwan600PNum,
    });

    list.push({
        text: "拖延率",
        total: getPercent(returnedSwan600Num + returnedSwan600PNum, swan600Total + swan600PTotal),
        swan600: getPercent(returnedSwan600Num, swan600Total),
        swan600P: getPercent(returnedSwan600PNum, swan600PTotal),
    });


    console.log(list, '++++++++++++');

    return list;
}

